import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
    providedIn: 'root'
})
export class IndexServicesService {

    indexServicesChanged: EventEmitter<void> = new EventEmitter();

    notifyIndexServicesChange(): void {
        this.indexServicesChanged.emit();
    }
}
